import _http from "./httpService";

export function trackOrder(body) {
  return _http.post("api/trackFront", body);
}
